
type Props = {
    showTime: boolean;
    elementId: string;
    onClose: (state: boolean) => void;
}
const useCloseWhenClickOutside = ({ showTime, elementId, onClose }: Props) => {
    if (showTime) {
        const handleClickOutside = (event: MouseEvent) => {
            const timeKeeperElement = document.getElementById(elementId);
            if (timeKeeperElement && !timeKeeperElement.contains(event.target as Node)) {
                onClose(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }
}

export default useCloseWhenClickOutside